export default {"src":"/_next/static/media/icon_facebook.15c315d2.svg","height":200,"width":200};